import React from 'react';
import { ButtonProps } from './ButtonProps';

import './styles.css';
import useWindowSize from '../../../hooks/useWindowSize';
import useMobileAppRedirect from '../../../hooks/useMobileAppRedirect';

const Button: React.FC<ButtonProps> = ({ buttonText, buttonColor, customStyle, onClick, customClass, margin, deepLink, dtLink, webFallbackLink }) => {
	const device = useWindowSize();

	const { isMobileWeb, handleRedirect, getRedirectUrl } = useMobileAppRedirect();

	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();

		// Call the original onClick if provided
		if (onClick) {
			onClick();
		}

		// Handle smart redirection
		handleRedirect({
			deepLink,
			dtLink,
			webFallbackLink: webFallbackLink || dtLink, // Fallback to dtLink if webFallbackLink not provided
		});
	};

	const href = getRedirectUrl({
		deepLink,
		dtLink,
		webFallbackLink: webFallbackLink || dtLink,
	});

	return (
		<a
			href={href}
			className={`appBtn ${customClass || ''}`}
			onClick={handleClick}
			style={{ margin: margin, background: buttonColor, ...customStyle }}
			target={device === 'desktop' ? '_blank' : ''}
		>
			{buttonText}
		</a>
	);
};

export default Button;
